<template>
  <div class="edit-user-wrapper">
    <div class="input-content">
      <div class="item">
        <span class="title">姓名</span>
        <input class="basic-inp" placeholder="请输入" v-model="userName" type="text" @change="nameHandler"/>
        <span class="erro-tip" v-show="isErroName">请输入正确姓名</span>
      </div>
      <div class="item">
        <span class="title">手机号</span>
        <input class="basic-inp" placeholder="请输入" v-model="phoneNumber" type="tel" maxlength="11" @change="phoneHandler"/>
        <span class="erro-tip" v-show="isErroPhone">请输入正确的手机号</span>
      </div>
      <div class="item">
        <span class="title">验证码</span>
        <input class="basic-inp" placeholder="请输入" v-model="code" type="tel" maxlength="6" @change="codeHandler"/>
        <span class="erro-tip spe" v-show="isErroCode">验证码错误</span>
        <button class="get-code-btn" @click="getCode" :class="controlCodeClass">
          <span v-if="!isDowning">{{codeMsg}}</span>
          <span v-else>{{countDown}} (s)</span>
        </button>
      </div>
    </div>
    <div class="btn-style1">
      <button type="button" class="btn" :class="controlCommitClass" @click="toCommit" :disabled="controlCommitDisabled">确定</button>
    </div>
    <p class="friendly-tips">绑定后姓名和手机号不能更改</p>
  </div>

</template>

<script>
  import util from "@/common/utils"
  import { userInfo } from '@/apis'
  import { Toast } from 'mint-ui';
  import { mapState } from 'vuex'
  export default {
    data(){
      return {
        userName: '',
        phoneNumber: '',
        code: '',
        codeMsg: '获取验证码',
        isDowning: false,
        countDown: 60,
        isErroName: false,
        isErroPhone: false,
        isErroCode: false,
        isDisabled1: true,
        isDisabled2: true,
        patientId: ''
      }
    },
    computed: {
      controlCodeClass(){
        return this.phoneNumber.trim() ? '' : 'disabled';
      },
      controlCodeDisabled(){
        return this.phoneNumber.trim() ? false : true;
      },
      controlCommitClass(){
        return (this.userName.trim() && this.phoneNumber.trim() && this.code.trim()) ? '' : 'disabled'
      },
      controlCommitDisabled(){
        return (this.userName.trim() && this.phoneNumber.trim() && this.code.trim()) ? false : true;
      },
      ...mapState({
        openid: state => state.openid,
      })
    },
    created(){
    },
    methods: {
      //倒计时
      _timeCountDown () {
        this.countDown--;
        if (this.countDown === 0) {
          this.countDown = 60;
          this.isDowning = false;
          this.codeMsg = '重新获取'
          return;
        } else {
          setTimeout(this._timeCountDown, 1000);
        }
      },
      //获取验证码操作
      getCode(){
        if (this.isDowning){
          return;
        } else if(this.phoneNumber.trim() === ''){
          Toast('请先输入手机号');
        } else if(!util.verifyPhone(this.phoneNumber.trim())){
          this.isErroPhone = true;
        }else {
          this.isErroPhone = false;
          this.isDowning = true;
          this._timeCountDown();
          this.axios.get(userInfo.signatureCode,{
            params:{
              mobile:this.phoneNumber.trim()
            }
          }).then((data) => {
            let res = data.data;
            if(res.code === '000000'){
              let signature = res.data.signature;
              this.axios.post(userInfo.sendVerifyCode,{
                mobile:this.phoneNumber.trim(),
                signature: signature
              }).then((data) => {
                let res = data.data;
                if(res.code === '000000'){
                  Toast('短信已发送成功');
                }else {
                  Toast(res.message);
                }
              }).catch(function (error) {
                console.log(error);
              });
            }else {
              Toast(res.message);
            }
          }).catch(function (error) {
            console.log(error);
          });
        }
      },
      //姓名输入失焦提醒
      nameHandler(){
        if(this.userName.trim() != '' && !util.verifyName(this.userName.trim())){
          this.isErroName = true;
        }else {
          this.isErroName = false;
        }
      },
      //手机号输入失焦提醒
      phoneHandler(){
        if(util.verifyPhone(this.phoneNumber.trim()) || this.phoneNumber.trim() === ''){
          this.isErroPhone = false;
        }else if(this.phoneNumber.trim() != '' && !util.verifyPhone(this.phoneNumber.trim())){
          this.isErroPhone = true;
        }
      },
      //验证码输入失焦提醒
      codeHandler(){
        if(this.code.trim() != '' && !util.verifyCheckCode(this.code.trim())){
          this.isErroCode = true;
        }else {
          this.isErroCode = false;
        }
      },
    //  点击确定操作
      toCommit(){
        if(!util.verifyName(this.userName.trim())){
          this.isErroName = true;
        }
        if(!util.verifyPhone(this.phoneNumber)){
          this.isErroPhone = true;
        }
        if(!util.verifyCheckCode(this.code)){
          this.isErroCode = true;
        }
        if(util.verifyName(this.userName) && util.verifyPhone(this.phoneNumber) && util.verifyCheckCode(this.code)){
          this.axios.post(userInfo.bindPatientsInfo,{
            nickName:this.userName.trim(),
            mobilePhone: this.phoneNumber.trim(),
            code: this.code.trim(),
            openId: this.openid
          }).then((data) => {
            let res = data.data;
            if(res.code === '000000'){
              this.patientId = res.data.id;
              this.$router.push({
                path: '/editResult'
              })
            }else {
              Toast(res.message);
            }
          }).catch(function (error) {
            console.log(error);
          });
        }
      },
    },
    components: {

    }
  }
</script>

<style scoped lang="scss">
  .edit-user-wrapper{
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    .input-content{
      width: 100%;
      box-sizing: border-box;
      .item{
        box-sizing: border-box;
        height: 46px;
        border-bottom: 1PX solid #EEEEEE;
        @include flex;
        @include align-items;
        padding-right: 15px;
        .title{
          width: 95px;
          display: inline-block;
          text-align: right;
          padding-right: 35px;
          box-sizing: border-box;
          font-size: 15px;
          color: #666666;
        }
        .basic-inp{
          @include flex-value(1);
          box-sizing: border-box;
          font-size: 15px;
          color: #333333;
          height: 45px;
          line-height: 21px;
          min-width: 90px;
        }
        .basic-inp::-webkit-input-placeholder{
          color:#CCCCCC;
        }
        .get-code-btn{
          box-sizing: border-box;
          display: inline-block;
          padding: 0 10px;
          height: 32px;
          line-height: 32px;
          background-color: #41B7A7;
          color: #ffffff;
          font-size: 13px;
          border-radius: 3px;
          outline: none;
          -webkit-appearance: none;
          border: none;
          &.disabled{
            background-color: #CCCCCC;
          }
        }
        .erro-tip{
          color: #FF6363;
          font-size: 12px;
          &.spe{
            margin-right: 15px;
          }
        }
      }
    }
    .btn-style1{
      width: 100%;
      box-sizing: border-box;
      padding: 0 15px;
      height: 45px;
      margin-top: 45px;
      .btn{
        width: 100%;
        height: 45px;
        line-height: 45px;
        text-align: center;
        border-radius: 23px;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 1px;
        background-color: #41B7A7;
        outline: none;
        -webkit-appearance: none;
        border: none;
        /*border-color: transparent;*/
        &.disabled{
          background-color: #CCCCCC;
        }
      }
    }
    .friendly-tips{
      text-align: center;
      margin-top: 20px;
      color: #666666;
      font-size: 13px;
      line-height: 19px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/goBind/editUserInfo.vue